// // src/pages/item_deliveries/ItemDeliveryForm.js
// import {
//   Box,
//   Button,
//   FormHelperText,
//   MenuItem,
//   Select,
//   TextField,
// } from '@mui/material';
// import React, { useEffect, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import { Formik } from 'formik';
// import * as Yup from 'yup';
// import AdminHeader from '../../components/AdminHeader';
// import LayoutContainer from '../../components/LayoutContainer';
// import itemService from '../../services/itemService';
// import stationService from '../../services/stationService';
// import { find, isEmpty, map } from 'lodash';
// import moment from 'moment';
// import userService from '../../services/userService';
// import locationService from '../../services/locationService';
// import eventService from '../../services/eventService';
// import allotedItemsService from '../../services/allotedItemsService';
// import departmentService from '../../services/departmentService';
// import itemDeliveryService from '../../services/itemDeliveryService';

// const DeliveredItemForm = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [items, setItems] = useState([]);
//   const [departments, setDepartment] = useState([]);
//   const [initialValues, setInitialValues] = useState({
//     user_id: localStorage?.getItem('user_id') || 1,
//     item_id: '',
//     allocated_qty: '',
//     delivered_qty: '',
//     photo: '',
//     department_id: '',
//     event_id: localStorage?.getItem('event_id') || 1,
//   });

//   useEffect(() => {
//     const fetchItemDelivery = async () => {
//       if (id) {
//         const response = await allotedItemsService.getAllotedItem(id);
//         setInitialValues(response.data);
//       }
//     };
//     fetchItemDelivery();
//   }, [id]);

//   const fetchDepartment = async () => {
//     const response = await departmentService.getDepartments();
//     setDepartment(response.data);
//   };

//   useEffect(() => {
//     fetchDepartment();
//   }, []);

//   const validationSchema = Yup.object().shape({
//     item_id: Yup.number().required('Item is required'),
//     allocated_qty: Yup.number()
//       .required('Alloted Quantity is required')
//       .min(1, 'Alloted Quantity must be greater than zero'),
//     delivered_qty: Yup.number()
//       .required('Alloted Quantity is required')
//       .min(1, 'Alloted Quantity must be greater than zero'),
//     department_id: Yup.number().required('Station is required'),
//     // event_id: Yup.number().required('Event is required'),
//     // user_id: Yup.number().required('User is required'),
//   });

//   const handleSubmit = async (values, { setSubmitting }) => {
//     try {
//       if (id) {
//         await itemDeliveryService.updateItemDelivery(id, [values]);
//       } else {
//         await itemDeliveryService.createItemDelivery([values]);
//       }
//       navigate('/delivered-items');
//     } catch (error) {
//       console.error(error); // Handle error appropriately
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const fetchItems = async () => {
//     const response = await itemService.getItems();
//     setItems(response.data);
//   };

//   // const fetchStations = async () => {
//   //   const response = await stationService.getStations();
//   //   setStations(response.data);
//   // };

//   useEffect(() => {
//     fetchItems();
//     // fetchStations();
//   }, []);

//   const labelStyle = {
//     color: '#000',
//     fontSize: '0.87rem',
//     marginTop: 8,
//   };

//   return (
//     <LayoutContainer>
//       <AdminHeader
//         title={id ? 'Edit Delivery Item' : 'Add Delivery Item'}
//         backTo='/delivered-items'
//       />
//       <div className='page-content-wrapper scrollable'>
//         <Formik
//           initialValues={initialValues}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmit}
//           enableReinitialize
//         >
//           {({
//             handleChange,
//             handleBlur,
//             handleSubmit,
//             values,
//             errors,
//             touched,
//             setFieldValue,
//           }) => (
//             <form onSubmit={handleSubmit}>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
//                 <div style={labelStyle}>Item</div>
//                 <Select
//                   name='item_id'
//                   value={values.item_id}
//                   fullWidth
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                   {!isEmpty(items) ? (
//                     map(items, (option) => (
//                       <MenuItem key={option?.id} value={option?.id}>
//                         {option?.item_name}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem>No data found</MenuItem>
//                   )}
//                 </Select>
//                 {touched.item_id && errors.item_id && (
//                   <FormHelperText style={{ color: '#D32F2F' }}>
//                     {errors.item_id}
//                   </FormHelperText>
//                 )}
//               </Box>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
//                 <div style={labelStyle}>Alloted Quantity</div>
//                 <TextField
//                   name='allocated_qty'
//                   fullWidth
//                   type='number'
//                   value={values.allocated_qty}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 />
//                 {touched.allocated_qty && errors.allocated_qty && (
//                   <FormHelperText style={{ color: '#D32F2F' }}>
//                     {errors.allocated_qty}
//                   </FormHelperText>
//                 )}
//               </Box>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
//                 <div style={labelStyle}>Delivery Quantity</div>
//                 <TextField
//                   name='delivered_qty'
//                   fullWidth
//                   type='number'
//                   value={values.delivered_qty}
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 />
//                 {touched.delivered_qty && errors.delivered_qty && (
//                   <FormHelperText style={{ color: '#D32F2F' }}>
//                     {errors.delivered_qty}
//                   </FormHelperText>
//                 )}
//               </Box>
//               {/* <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
//                 <div style={labelStyle}>User</div>
//                 <Select
//                   name='user_id'
//                   value={values.user_id}
//                   fullWidth
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                   {!isEmpty(users) ? (
//                     map(users, (option) => (
//                       <MenuItem key={option?.id} value={option?.id}>
//                         {option?.username}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem>No data found</MenuItem>
//                   )}
//                 </Select>
//                 {touched.user_id && errors.user_id && (
//                   <FormHelperText style={{ color: '#D32F2F' }}>
//                     {errors.user_id}
//                   </FormHelperText>
//                 )}
//               </Box>
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
//                 <div style={labelStyle}>Events </div>
//                 <Select
//                   name='event_id'
//                   value={values.event_id}
//                   fullWidth
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                   {!isEmpty(events) ? (
//                     map(events, (option) => (
//                       <MenuItem key={option?.id} value={option?.id}>
//                         {option?.name}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem>No data found</MenuItem>
//                   )}
//                 </Select>
//                 {touched.item_id && errors.item_id && (
//                   <FormHelperText style={{ color: '#D32F2F' }}>
//                     {errors.item_id}
//                   </FormHelperText>
//                 )}
//               </Box> */}
//               <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
//                 <div style={labelStyle}>Station</div>
//                 <Select
//                   name='department_id'
//                   value={values.department_id}
//                   fullWidth
//                   onChange={handleChange}
//                   onBlur={handleBlur}
//                 >
//                   {!isEmpty(departments) ? (
//                     map(departments, (option) => (
//                       <MenuItem key={option?.id} value={option?.id}>
//                         {option?.name}
//                       </MenuItem>
//                     ))
//                   ) : (
//                     <MenuItem>No data found</MenuItem>
//                   )}
//                 </Select>
//                 {touched.department_id && errors.department_id && (
//                   <FormHelperText style={{ color: '#D32F2F' }}>
//                     {errors.department_id}
//                   </FormHelperText>
//                 )}
//               </Box>
//               <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
//                 <Button
//                   type='submit'
//                   variant='contained'
//                   sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
//                 >
//                   {id ? 'Update' : 'Create'}
//                 </Button>
//               </Box>
//             </form>
//           )}
//         </Formik>
//       </div>
//     </LayoutContainer>
//   );
// };

// export default DeliveredItemForm;

// import React, { useEffect, useState } from 'react';
// import {
//   Container,
//   TextField,
//   Button,
//   Box,
//   Typography,
//   Paper,
//   IconButton,
//   Select,
//   MenuItem,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   useMediaQuery,
//   InputLabel,
// } from '@mui/material';
// import { MdArrowBackIos, MdCameraAlt, MdHome } from 'react-icons/md';
// import { FaImage } from 'react-icons/fa6';
// import {
//   filter,
//   find,
//   findIndex,
//   isEmpty,
//   map,
//   omit,
//   sum,
//   uniq,
//   uniqBy,
// } from 'lodash';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import fileUploadService from '../../services/fileUploadService';
// import itemDeliveryService from '../../services/itemDeliveryService';
// import eventService from '../../services/eventService';
// import itemTypeService from '../../services/itemTypeService';
// import itemService from '../../services/itemService';
// import AdminHeader from '../../components/AdminHeader';

// const DeliveredItemForm = () => {
//   const navigate = useNavigate();
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [file, setFile] = useState(null);
//   const [departments, setDepartments] = useState([]);
//   const [itemTypes, setItemTypes] = useState([]);
//   const [items, setItems] = useState([]);
//   const [itemDeliveries, setItemDeliveries] = useState([]);
//   const [allocations, setAllocations] = useState([]);
//   const [selectedDepartment, setSelectedDepartment] = useState('');

//   const handleFileChange = async (event) => {
//     const file = event.target.files[0];
//     setSelectedFile(file);
//     const res = await fileUploadService?.handleFileUpload(file);
//     if (res?.status === 200) {
//       setFile(
//         `https://procam.pythonanywhere.com/static/images/${res?.data?.filename}`
//       );
//     }
//   };

//   const handleSubmit = async () => {
//     const data = map(uniqBy(allocations, 'id'), (allocation) =>
//       omit(allocation, [
//         'timestamp',
//         'entered_qty',
//         'department_name',
//         'user_name',
//         'item_name',
//         'event_name',
//       ])
//     );
//     const res = await itemDeliveryService?.updateItemDelivery(0, data);
//     if (res?.status === 200) {
//       // setDeliveryQty(0)
//       // setItemDeliveries(
//       //   map(itemDeliveries, (data) => {
//       //     return {
//       //       ...data,
//       //       delivered_qty: '',
//       //       entered_qty : ''
//       //     };
//       //   })
//       // );
//       // fetchItemDeliveries();
//       toast?.success('item delivered successfully');
//     }
//   };
//   // const fetchDepartment = async () => {
//   //   const response = await departmentService.getDepartments();
//   //   setDepartments(response.data);
//   // };

//   const fetchDepartment = async () => {
//     const res = await eventService?.getEventDetail();
//     if (res?.status === 200) {
//       setDepartments(
//         filter(res?.data, {
//           event_id: parseInt(localStorage?.getItem('event_id')),
//         })
//       );
//     }
//   };

//   const fetchItemTypes = async () => {
//     const response = await itemTypeService.getItemTypes();
//     setItemTypes(response.data);
//   };

//   const fetchItems = async () => {
//     const response = await itemService.getItems();
//     setItems(response.data);
//   };

//   const fetchItemDeliveries = async () => {
//     const response = await itemDeliveryService.getItemDeliveries();
//     setItemDeliveries(
//       filter(
//         response.data,
//         (data) =>
//           data?.department_id === selectedDepartment &&
//           data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
//           data?.allocated_qty !== 0
//       )
//     );
//   };

//   useEffect(() => {
//     if (selectedDepartment) {
//       fetchItemDeliveries();
//     }
//   }, [selectedDepartment]);

//   useEffect(() => {
//     fetchDepartment();
//     fetchItemTypes();
//     fetchItems();
//   }, []);

//   const handleInputChange = (id, value, item) => {
//     const quantity = parseInt(value, 10);
//     const newAllocation = {
//       ...item,
//       delivered_qty: quantity,
//     };

//     const existingIndex = findIndex(allocations, { id: id });

//     if (existingIndex >= 0) {
//       const updatedAllocations = [...allocations];
//       updatedAllocations[existingIndex] = newAllocation;
//       setAllocations(updatedAllocations);
//     } else {
//       setAllocations([...allocations, newAllocation]);
//     }
//   };

//   return (
//     <>
//       <AdminHeader title={'Inward Delivery'} />
//       <div className='page-content-wrapper scrollable'>
//         <Paper elevation={2} sx={{ padding: 2, borderRadius: 2, m: 1 }}>
//           <Box component='form'>
//             <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
//               <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
//                 Select Station
//               </Typography>
//               <Select
//                 name='department_id'
//                 value={selectedDepartment}
//                 fullWidth
//                 onChange={(e) => setSelectedDepartment(e?.target?.value)}
//                 variant='outlined'
//                 sx={{ mb: 1 }}
//               >
//                 {!isEmpty(departments) ? (
//                   map(departments, (option) => (
//                     <MenuItem
//                       key={option?.department_id}
//                       value={option?.department_id}
//                     >
//                       {option?.department_name}
//                     </MenuItem>
//                   ))
//                 ) : (
//                   <MenuItem>No data found</MenuItem>
//                 )}
//               </Select>
//               {!selectedDepartment && (
//                 <Typography
//                   variant='caption'
//                   sx={{ fontSize: '0.7rem', color: 'red' }}
//                 >
//                   Station is required
//                 </Typography>
//               )}
//             </Box>

//             {selectedDepartment && (
//               <>
//                 {itemDeliveries.map((item) => {
//                   // const enteredValue =
//                   //   item.entered_qty || item?.delivered_qty || 0;
//                   // const remainingQty = item.allocated_qty - enteredValue;
//                   // const itemName = find(items, { id: item?.item_id })?.item_name;
//                   // const itemType = find(itemTypes, {
//                   //   id: find(items, { id: item?.item_id })?.item_type_id,
//                   // })?.type;

//                   // Set enteredValue to item.entered_qty if it's not null, undefined, or an empty string
//                   const enteredValue =
//                     item.entered_qty !== undefined &&
//                     item.entered_qty !== null &&
//                     item.entered_qty !== ''
//                       ? item?.entered_qty
//                       : item?.delivered_qty; // Default to 0 only if no value has been entered

//                   const remainingQty = item.allocated_qty - enteredValue;
//                   const itemName = find(items, {
//                     id: item?.item_id,
//                   })?.item_name;
//                   const itemType = find(itemTypes, {
//                     id: find(items, { id: item?.item_id })?.item_type_id,
//                   })?.type;

//                   return (
//                     <Box key={item.id} sx={{ mb: 2 }}>
//                       {/* <Box
//                       sx={{ display: 'flex', justifyContent: 'space-between' }}
//                     >
//                       <Typography
//                         variant='body2'
//                         sx={{ fontWeight: '550 !important' }}
//                       >
//                         {itemName} ({itemType}){' '}
//                       </Typography>
//                       <Typography
//                         variant='caption'
//                         sx={{
//                           mt: 0.5,
//                           fontWeight: '550 !important',
//                           fontSize: '0.75rem !important',
//                         }}
//                       >
//                         Remaining: {remainingQty}
//                       </Typography>
//                     </Box> */}
//                       <Box
//                         sx={{
//                           display: 'flex',
//                           flexDirection: { xs: 'column', md: 'row' },
//                           gap: 1,
//                           mt: 1,
//                           width: '100%',
//                         }}
//                       >
//                         <div
//                           style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             gap: 8,
//                             width: '100%',
//                           }}
//                         >
//                           <InputLabel
//                             sx={{
//                               fontWeight: '500!important',
//                             }}
//                             variant='title'
//                           >
//                             Product
//                           </InputLabel>
//                           <Typography
//                             variant='body2'
//                             sx={{ fontWeight: '550 !important' }}
//                           >
//                             {itemName} ({itemType}){' '}
//                           </Typography>
//                         </div>
//                         <div
//                           style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             width: '100%',
//                           }}
//                         >
//                           <InputLabel>Allocated qty</InputLabel>
//                           <TextField
//                             type='number'
//                             disabled
//                             inputProps={{ min: 0 }}
//                             value={item.allocated_qty}
//                             variant='outlined'
//                             size='small'
//                             fullWidth
//                           />
//                         </div>
//                         <div
//                           style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             width: '100%',
//                           }}
//                         >
//                           <InputLabel
//                             sx={{
//                               fontWeight: '500!important',
//                             }}
//                             variant='title'
//                           >
//                             Prev Delivered qty
//                           </InputLabel>
//                           <TextField
//                             disabled
//                             type='number'
//                             value={item?.delivered_qty}
//                             variant='outlined'
//                             size='small'
//                             fullWidth
//                           />
//                         </div>
//                         <div
//                           style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             width: '100%',
//                           }}
//                         >
//                           <InputLabel
//                             sx={{
//                               fontWeight: '500!important',
//                             }}
//                             variant='title'
//                           >
//                             Current Delivery qty
//                           </InputLabel>
//                           <TextField
//                             type='number'
//                             // disabled={
//                             //   item?.allocated_qty === item?.delivered_qty
//                             // }
//                             onChange={(e) => {
//                               const newValue = sum([
//                                 item?.delivered_qty,
//                                 Number(e.target.value),
//                               ]);
//                               handleInputChange(item.id, newValue, item);
//                               item.entered_qty = newValue;
//                             }}
//                             variant='outlined'
//                             size='small'
//                             fullWidth
//                             sx={{
//                               '& .MuiOutlinedInput-notchedOutline': {
//                                 border: '1px solid #1876D1',
//                               },
//                             }}
//                           />
//                         </div>
//                         <div
//                           style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             width: '100%',
//                           }}
//                         >
//                           <InputLabel
//                             sx={{
//                               fontWeight: '500!important',
//                             }}
//                             variant='title'
//                           >
//                             Balance
//                           </InputLabel>
//                           <TextField
//                             type='number'
//                             disabled
//                             inputProps={{ min: 0 }}
//                             value={remainingQty}
//                             variant='outlined'
//                             size='small'
//                             fullWidth
//                           />
//                         </div>
//                       </Box>
//                     </Box>
//                   );
//                 })}
//               </>
//             )}

//             {selectedDepartment && (
//               <Box display='flex' justifyContent='flex-end' sx={{ mt: 3 }}>
//                 <Button
//                   variant='contained'
//                   color='primary'
//                   onClick={handleSubmit}
//                 >
//                   Submit
//                 </Button>
//               </Box>
//             )}
//           </Box>
//         </Paper>
//       </div>
//     </>
//   );
// };

// export default DeliveredItemForm;

import React, { useEffect, useState } from 'react';
import {
  Container,
  TextField,
  Button,
  Box,
  Typography,
  Paper,
  IconButton,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useMediaQuery,
  InputLabel,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import { MdArrowBackIos, MdCameraAlt, MdHome } from 'react-icons/md';
import { FaImage } from 'react-icons/fa6';
import {
  filter,
  find,
  findIndex,
  isEmpty,
  map,
  omit,
  sortBy,
  startsWith,
  sum,
  uniq,
  uniqBy,
} from 'lodash';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import fileUploadService from '../../services/fileUploadService';
import itemDeliveryService from '../../services/itemDeliveryService';
import eventService from '../../services/eventService';
import itemTypeService from '../../services/itemTypeService';
import itemService from '../../services/itemService';
import AdminHeader from '../../components/AdminHeader';
import { ImageModal } from '../supervisor/SupervisorForm';

const DeliveredItemForm = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [file, setFile] = useState(null);
  const [departments, setDepartments] = useState([]);
  const [itemTypes, setItemTypes] = useState([]);
  const [items, setItems] = useState([]);
  const [itemDeliveries, setItemDeliveries] = useState([]);
  const [allocations, setAllocations] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [imageUploading, setImageLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false); // Modal visibility state
  const [selectedImage, setSelectedImage] = useState(null); // Store the item to be edited
  // const [balanceError, setBalanceError] = useState(false); // Track balance error

  const handleFileChange = async (event) => {
    try {
      setImageLoading(true);
      const file = event.target.files[0];
      const newFile = new File([file], `Delivered_photo_${file?.name}`, {
        type: file.type,
      });
      setSelectedFile(newFile);
      const res = await fileUploadService?.handleFileUpload(newFile);
      if (res?.status === 200) {
        setFile(`${res?.data?.filename}`);
      }
    } catch {
      setImageLoading(false);
    } finally {
      setImageLoading(false);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedImage(null);
  };

  const handleSubmit = async () => {
    const data = map(
      map(uniqBy(allocations, 'id'), (data) => {
        const photosToAdd = Array.isArray(file) ? file : [file];
        return {
          ...data,
          photo: data.photo
            ? `${data.photo}, ${photosToAdd.join(', ')}`
            : photosToAdd.join(', '),
          remarks: 'delivered',
          // station: selectedDepartment,
          station_type: data?.station_type,
          user_id: parseInt(localStorage?.getItem('user_id')),
          // photo: startsWith(data?.photo, 'Pickup')
          //   ? `${data.photo}, ${file}`
          //   : file,
        };
      }),
      (allocation) =>
        omit(allocation, [
          'timestamp',
          'entered_qty',
          'department_name',
          'user_name',
          'item_name',
          'event_name',
          'station'
        ])
    );
    try {
      const res = await itemDeliveryService?.updateItemDelivery(selectedDepartment, data);
      if (res?.status === 200) {
        toast?.success('item delivered successfully');
      }
    } catch (e) {
      toast.error(e?.response?.data?.message);
    }
  };

  const fetchDepartment = async () => {
    const res = await eventService?.getEventDetail();
    if (res?.status === 200) {
      setDepartments(
        filter(res?.data, {
          event_id: parseInt(localStorage?.getItem('event_id')),
        })
      );
    }
  };

  const fetchItemTypes = async () => {
    const response = await itemTypeService.getItemTypes();
    setItemTypes(response.data);
  };

  const fetchItems = async () => {
    const response = await itemService.getItemDetails();
    setItems(response.data);
  };

  const [loading, setLoading] = useState(false);

  const fetchItemDeliveries = async () => {
    try {
      setLoading(true); // Start loading

      const response = await itemDeliveryService.getItemDeliveries(
        localStorage?.getItem('event_id')
      );

      if (selectedDepartment) {
        setItemDeliveries(
          sortBy(
            filter(
              response.data,
              (data) =>
                data?.station === selectedDepartment &&
                data?.event_id ===
                  parseInt(localStorage?.getItem('event_id')) &&
                data?.allocated_qty !== 0
            ),
            'item_name'
          )
        );
      } else {
        setDepartments(
          uniqBy(
            filter(response.data, {
              event_id: parseInt(localStorage?.getItem('event_id')),
            }),
            'station'
          )
        );
      }
    } catch (error) {
      console.error('Error fetching item deliveries:', error);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  // const fetchItemDeliveries = async () => {
  //   const response = await itemDeliveryService.getItemDeliveries(
  //     localStorage?.getItem('event_id')
  //   );
  //   if (selectedDepartment) {
  //     setItemDeliveries(
  //       sortBy(
  //         filter(
  //           response.data,
  //           (data) =>
  //             data?.station === selectedDepartment &&
  //             data?.event_id === parseInt(localStorage?.getItem('event_id')) &&
  //             data?.allocated_qty !== 0
  //         ),
  //         'item_name'
  //       )
  //     );
  //   } else {
  //     setDepartments(
  //       uniqBy(
  //         filter(response.data, {
  //           event_id: parseInt(localStorage?.getItem('event_id')),
  //         }),
  //         'station'
  //       )
  //     );
  //   }
  // };

  useEffect(() => {
    fetchItemDeliveries();
    setAllocations([]);
  }, [selectedDepartment]);

  useEffect(() => {
    fetchItems();
  }, []);

  const handleInputChange = (id, value, item) => {
    const quantity = parseInt(value, 10);
    const newAllocation = {
      ...item,
      delivered_qty: quantity,
    };

    const existingIndex = findIndex(allocations, { id: id });

    if (existingIndex >= 0) {
      const updatedAllocations = [...allocations];
      updatedAllocations[existingIndex] = newAllocation;
      setAllocations(updatedAllocations);
    } else {
      setAllocations([...allocations, newAllocation]);
    }
  };

  // const checkBalanceError = (item) => {
  //   const enteredValue =
  //     item?.entered_qty !== undefined &&
  //     item?.entered_qty !== null &&
  //     item?.entered_qty !== ''
  //       ? item?.entered_qty
  //       : item?.delivered_qty;

  //   const remainingQty = item?.allocated_qty - enteredValue;

  //   return remainingQty < 0;
  // };

  // useEffect(() => {
  //   const hasNegativeBalance = itemDeliveries.some(checkBalanceError);
  //   setBalanceError(hasNegativeBalance);
  // }, [allocations]);

  return (
    <>
      <AdminHeader title='INWARD DELIVERY' />
      <div className='page-content-wrapper scrollable'>
        <Paper elevation={2} sx={{ padding: 2, borderRadius: 2, m: 1 }}>
          <Box component='form'>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Typography
                variant='body1'
                sx={{ fontWeight: 'bold', fontSize: '0.675rem' }}
              >
                SELECT STATION
              </Typography>
              <Select
                name='department_id'
                value={selectedDepartment}
                fullWidth
                onChange={(e) => {
                  setSelectedDepartment(e?.target?.value);
                  setAllocations([]);
                  setItemDeliveries([]);
                  setSelectedFile(null);
                  setFile(null);
                }}
                variant='outlined'
                sx={{ mb: 1, fontSize: '0.675rem' }}
              >
                {!isEmpty(departments) ? (
                  map(departments, (option) => (
                    <MenuItem
                      key={option?.station}
                      value={option?.station}
                      sx={{ fontSize: '0.675rem' }}
                    >
                      {option?.station}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>No data found</MenuItem>
                )}
              </Select>
              {!selectedDepartment && (
                <Typography
                  variant='caption'
                  sx={{ fontSize: '0.7rem', color: 'red' }}
                >
                  Station is required
                </Typography>
              )}
            </Box>
            <Backdrop
              sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={loading}
            >
              <CircularProgress color='inherit' />
            </Backdrop>
            {selectedDepartment && (
              <>
                {itemDeliveries.map((item) => {
                  const enteredValue =
                    item.entered_qty !== undefined &&
                    item.entered_qty !== null &&
                    item.entered_qty !== ''
                      ? item?.entered_qty
                      : item?.delivered_qty;

                  const remainingQty = item.allocated_qty - enteredValue;

                  // Check if the balance is negative for error display
                  // const isBalanceNegative = checkBalanceError(item);

                  return (
                    <Box key={item.id} sx={{ mb: 2 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: { xs: 'column', md: 'row' },
                          gap: 1,
                          mt: 1,
                          width: '100%',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                            width: '100%',
                          }}
                        >
                          <InputLabel
                            sx={{
                              fontWeight: '500!important',
                              fontSize: '0.675rem',
                            }}
                            variant='title'
                          >
                            PRODUCT
                          </InputLabel>
                          <Typography
                            variant='body2'
                            sx={{
                              fontWeight: '550 !important',
                              fontSize: '0.675rem',
                            }}
                          >
                            {item?.item_name}
                          </Typography>
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                          }}
                        >
                          <InputLabel sx={{ fontSize: '0.675rem' }}>
                            ALLOCATED QTY
                          </InputLabel>
                          <TextField
                            type='number'
                            disabled
                            inputProps={{ min: 0 }}
                            sx={{
                              '& .MuiOutlinedInput-input': {
                                textAlign: 'right',
                              },
                            }}
                            value={item.allocated_qty}
                            variant='outlined'
                            size='small'
                            fullWidth
                          />
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                          }}
                        >
                          <InputLabel
                            sx={{
                              fontWeight: '500!important',
                              fontSize: '0.675rem',
                            }}
                            variant='title'
                          >
                            PREV DELIVERED QTY
                          </InputLabel>
                          <TextField
                            disabled
                            type='number'
                            value={item?.delivered_qty}
                            sx={{
                              '& .MuiOutlinedInput-input': {
                                textAlign: 'right',
                              },
                            }}
                            variant='outlined'
                            size='small'
                            fullWidth
                          />
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                          }}
                        >
                          <InputLabel
                            sx={{
                              fontWeight: '500!important',
                              fontSize: '0.675rem',
                            }}
                            variant='title'
                          >
                            CURRENT DELIVERED QTY
                          </InputLabel>
                          <TextField
                            type='number'
                            onChange={(e) => {
                              const newValue = sum([
                                item?.delivered_qty,
                                Number(e.target.value),
                              ]);
                              handleInputChange(item.id, newValue, item);
                              item.entered_qty = newValue;
                            }}
                            variant='outlined'
                            sx={{
                              '& .MuiOutlinedInput-input': {
                                textAlign: 'right',
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                border: '1px solid #1876D1',
                              },
                            }}
                            size='small'
                            fullWidth
                          />
                          {/* {isBalanceNegative && (
                            <Typography
                              variant='caption'
                              sx={{ fontSize: '0.7rem', color: 'red' }}
                            >
                              Please eneter valid value
                            </Typography>
                          )} */}
                        </div>
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                          }}
                        >
                          <InputLabel
                            sx={{
                              fontWeight: '500!important',
                              fontSize: '0.675rem',
                            }}
                            variant='title'
                          >
                            BALANCE
                          </InputLabel>
                          <TextField
                            type='number'
                            disabled
                            inputProps={{ min: 0 }}
                            sx={{
                              '& .MuiOutlinedInput-input': {
                                textAlign: 'right',
                              },
                            }}
                            value={remainingQty}
                            variant='outlined'
                            size='small'
                            fullWidth
                          />
                        </div>
                      </Box>
                    </Box>
                  );
                })}
              </>
            )}

            {selectedDepartment &&
              (imageUploading ? (
                <CircularProgress size={22} />
              ) : (
                <Box
                  display='flex'
                  justifyContent='space-between'
                  gap={1}
                  sx={{ mt: 3 }}
                >
                  {file && (
                    <Box
                      component='img'
                      src={URL.createObjectURL(selectedFile)}
                      alt='Selected'
                      onClick={() => {
                        setOpenModal(true);
                        setSelectedImage(file);
                      }}
                      sx={{
                        maxWidth: 50,
                        maxHeight: 50,
                        borderRadius: 1,
                        objectFit: 'cover',
                        cursor: 'pointer',
                      }}
                    />
                  )}
                  <Box
                    display='flex'
                    justifyContent='flex-end'
                    gap={1}
                    sx={{ mt: 3, width: '100%' }}
                  >
                    <input
                      accept='image/*'
                      style={{ display: 'none' }}
                      id='upload-file'
                      type='file'
                      onChange={handleFileChange}
                    />
                    <Button
                      component='label'
                      htmlFor='upload-file'
                      variant='contained'
                      disabled={isEmpty(itemDeliveries)}
                      sx={{ textTransform: 'none', fontSize: '0.675rem' }}
                    >
                      UPLOAD FILE
                    </Button>
                    <Button
                      variant='contained'
                      color='primary'
                      onClick={handleSubmit}
                      disabled={
                        isEmpty(itemDeliveries) ||
                        isEmpty(allocations) ||
                        loading
                      }
                      sx={{ fontSize: '0.675rem' }}
                    >
                      SUBMIT
                    </Button>
                  </Box>
                </Box>
              ))}
          </Box>
        </Paper>
      </div>
      {openModal && (
        <ImageModal
          open={openModal}
          handleClose={handleCloseModal}
          imageUrl={selectedImage}
        />
      )}
    </>
  );
};

export default DeliveredItemForm;
